import { render, staticRenderFns } from "./SdkSearch.vue?vue&type=template&id=b67f89b0&"
import script from "./SdkSearch.vue?vue&type=script&lang=js&"
export * from "./SdkSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b67f89b0')) {
      api.createRecord('b67f89b0', component.options)
    } else {
      api.reload('b67f89b0', component.options)
    }
    module.hot.accept("./SdkSearch.vue?vue&type=template&id=b67f89b0&", function () {
      api.rerender('b67f89b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkSearch.vue"
export default component.exports